import { useEffect } from "react";
import { useScrollToTop } from "@/hooks/useScrollToTop";
import { Header } from "@/components/Header";
import { FooterSection } from "@/components/FooterSection";
import { ConsultationForm } from "@/components/consultation/ConsultationForm";
import { Briefcase, BrainCircuit, Check } from "lucide-react";

export default function ScheduleConsultation() {
  useScrollToTop();

  useEffect(() => {
    document.title = "Schedule AI Consultation | DocketLabs";
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Schedule your AI consultation with legal experts. Tailored strategies, expert assessment & clear next steps. Book today.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Schedule your AI consultation with legal experts. Tailored strategies, expert assessment & clear next steps. Book today.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, []);

  return (
    <>
      <Header />
      
      <main className="bg-background">
        <div className="container mx-auto px-4 py-16 md:py-24">
          <div className="max-w-2xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-block px-8 py-6 rounded-2xl bg-gradient-to-r from-primary/20 via-accent/10 to-primary/20 backdrop-blur-sm border border-primary/30 shadow-lg shadow-primary/20">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-3 text-white">
                Schedule Your AI Consultation
              </h1>
              <p className="text-lg text-white/90">
                Get AI expertise tailored to your legal needs.
              </p>
            </div>
          </div>
            
            <div className="bg-card/50 backdrop-blur-sm p-6 md:p-8 rounded-xl border border-white/10 shadow-xl">
              <ConsultationForm />
            </div>
          </div>
        </div>
      </main>
      
      <FooterSection />
    </>
  );
}
